var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWarning3 = function SvgWarning3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M43.52 31.84 30.72 8.8C29 5.7 26.62 4 24 4s-5 1.7-6.72 4.8L4.48 31.84c-1.62 2.94-1.8 5.76-.5 7.98 1.3 2.22 3.86 3.44 7.22 3.44h25.6c3.36 0 5.92-1.22 7.22-3.44 1.3-2.22 1.12-5.06-.5-7.98Z",
    fill: "#EC928E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 29.5c-.82 0-1.5-.68-1.5-1.5V18c0-.82.68-1.5 1.5-1.5s1.5.68 1.5 1.5v10c0 .82-.68 1.5-1.5 1.5ZM24 36c-.12 0-.26-.02-.4-.04-.12-.02-.24-.06-.36-.12-.12-.04-.24-.1-.36-.18l-.3-.24c-.36-.38-.58-.9-.58-1.42 0-.52.22-1.04.58-1.42l.3-.24c.12-.08.24-.14.36-.18.12-.06.24-.1.36-.12.26-.06.54-.06.78 0 .14.02.26.06.38.12.12.04.24.1.36.18l.3.24c.36.38.58.9.58 1.42 0 .52-.22 1.04-.58 1.42l-.3.24c-.12.08-.24.14-.36.18-.12.06-.24.1-.38.12-.12.02-.26.04-.38.04Z",
    fill: "#601410"
  })));
};
export default SvgWarning3;